<div class="tree-view" *ngIf="model">
  <h3 *ngIf="model.showTitle==true" id="tree_view_{{model.treeNodeId}}" class="treeview-title">{{model.treeTitle}}</h3>
        <ng-container *ngTemplateOutlet="treeViewList; context:{ $implicit: model.items,role:'tree',treeid:model.treeNodeId,parentid:'root',lid:'0' }">
        </ng-container>
</div>
<ng-template #treeViewList let-list let-role='role'  let-treeid="treeid" let-parentid="parentid" let-lid="lid" >
  <small id="lista-nav_{{treeid}}" class="sr-only">navigazione</small>
  <ul role="tree"
      class="tree-view-list"
      id="treeView_ul_{{treeid}}_{{parentid}}"
      aria-labelledby="lista-nav_{{treeid}}"
      *ngIf="isChildrenExists(list)" #ultags
  >
    <li *ngFor="let item of filterList(list); let i=index"
        [id]="getTreeItemId(item,treeid)"
        [attr.data-code]="item[model.cid]"
        [attr.data-childcount]="getChildCount(item)"
        [attr.data-index]="i"
        [attr.data-first]="i==0?1:0"
        [attr.data-last]="i==list.length-1?1:0"
        role="treeitem"
        (keydown)="executeKeydown($event)"
        [attr.aria-expanded]="collapsedState(item)"
        (drop)="drop($event, item)"
        (dragover)="dragOver($event, item)"
        #options>
      <span style="display: inline-block;">
        <i aria-hidden="true" [ngClass]="getExpandCollapseClass(item)" [id]="getIconId(item,treeid)" #icons></i>
        <a href="javascript:void(0);"  (click)="toggleSelectionEvent($event,item)"><span class="tree-item-label">{{item[model.lid]}}</span></a>
      </span>
      <ng-container *ngTemplateOutlet="treeViewList; context:{ $implicit: item.children,role:'group',treeid:model.treeNodeId,parentid:item.code  }">
      </ng-container>
    </li>
  </ul>
</ng-template>

<!--[draggable]="!item.root"
(dragstart)="dragStart($event, item)"
"-->

